import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, PointElement, LinearScale, Title, CategoryScale } from 'chart.js';

ChartJS.register(LineElement, PointElement, LinearScale, Title, CategoryScale);

const StepChart = ({ title, ChartData, Datasets }) => {
    const data = {
        labels: Object.keys(ChartData),
        datasets: Datasets || [
            {
                label: title,
                data: Object.values(ChartData),
                backgroundColor: "rgba(255,206,86,0.4)",
                borderColor: "rgba(255,206,86,1)",
                fill: false,
                stepped: true,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false, // Allow chart to resize freely
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 1,  // Ensure y-axis increments by whole numbers only
                },
                title: {
                    display: true,
                    text: title,
                },
            },
        },
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    boxWidth: 15,
                    boxHeight: 15,
                    font: {
                        size: 12
                    }
                },
            },
        },
    };

    return (
        <div style={{ position: 'relative', width: '100%', height: '500px' }}>
            <Line data={data} options={options} />
        </div>
    );
};

export default StepChart;